<template>
  <svg
    id="Timeline_pause_icon"
    data-name="Timeline pause icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <circle
      id="Ellipse_318"
      data-name="Ellipse 318"
      cx="12"
      cy="12"
      r="12"
      fill="#ffb400"
    />
    <path
      id="Path_2361"
      data-name="Path 2361"
      d="M11896.707,23651.955v8"
      transform="translate(-11887.707 -23643.955)"
      fill="none"
      stroke="#fff"
      stroke-linecap="round"
      stroke-width="3"
    />
    <path
      id="Path_2361-2"
      data-name="Path 2361"
      d="M11896.707,23651.955v8"
      transform="translate(-11881.707 -23643.955)"
      fill="none"
      stroke="#fff"
      stroke-linecap="round"
      stroke-width="3"
    />
  </svg>
</template>

<script>
export default {
  name: 'RoundPause',
}
</script>

<style lang="scss" scoped></style>
